export enum BatchesViewBy {
    groups,
    statuses
}

export type BatchesSortBy = 'Ship by date';